import React from "react";
import "./BackOffice.css";
import AppTheme from "./theme/AppTheme";
import AppRouter from "./AppRouter";

const BackOffice: React.FC = () => {
  return (
    <AppTheme>
      <AppRouter />
    </AppTheme>
  );
};

export default BackOffice;
